import Link from 'next/link';
import React from 'react';
import { useTranslation } from 'react-i18next';

const getItemTitle = ({
  lease,
  rooms,
  category,
  area,
  areaCurrency,
  location,
  isClearString = false,
  simpleData = false
}) => {
  const { t } = useTranslation();

  const typeItem = lease
    ? t('pages.current_item.for_lease')
    : t('pages.current_item.for_sale');

  const roomsString = rooms
    ? t('cards.item_card.rooms', {
        count: rooms
      })
    : '';

  const areaString = area ? `${area} ${areaCurrency}` : '';

  const title = `${simpleData ? '' : typeItem} ${roomsString} ${
    category?.toLowerCase() ?? ''
  } ${areaString}, `;

  const link = location?.path && (
    <Link href={location?.path}>{location?.fullName}</Link>
  );

  const clearString = `${title} ${location?.fullName ?? ''}`;
  if (isClearString) return clearString;

  return (
    <div className="cur-item-desc__title">
      {title}
      {link}
    </div>
  );
};

export default getItemTitle;
